import { default as AnchorLogoIcon } from './AnchorLogoIcon/index';
import { default as AnchorPayIcon } from './AnchorPayIcon/index';
import { default as ArrowIcon } from './ArrowIcon/index';
import { default as CheckmarkIcon } from './CheckmarkIcon/index';
import { default as CircularArrowIcon } from './CircularArrowIcon/index';
import { ClockIcon } from './ClockIcon/index';
import { default as DollarSignIcon } from './DollarSignIcon/index';
import { DownloadIcon } from './DownloadIcon/index';
import { default as ExternalLinkIcon } from './ExternalLinkIcon/index';
import { default as EyeDropperIcon } from './EyeDropperIcon/index';
import { GearIcon } from './GearIcon/index';
import { default as InfoIcon } from './InfoIcon/index';
import { default as JustifiedIcon } from './JustifiedIcon/index';
import { LockIcon } from './LockIcon/index';
import { default as MagnifyingGlassIcon } from './MagnifyingGlassIcon/index';
import { default as MicrophoneIcon } from './MicrophoneIcon/index';
import { OptionDotsIcon } from './OptionDotsIcon/index';
import { PauseIcon } from './PauseIcon/index';
import { PencilIcon } from './PencilIcon';
import { default as PlayIcon } from './PlayIcon/index';
import { PowerIcon } from './PowerIcon/index';
import { default as QuestionMarkIcon } from './QuestionMarkIcon/index';
import { default as QuoteIcon } from './QuoteIcon/index';
import { default as ReRecordIcon } from './ReRecordIcon/index';
import { TrashIcon } from './TrashIcon/index';
import { default as UpsidedownTriangleIcon } from './UpsidedownTriangleIcon/index';
import { VideoPlayerIcon } from './VideoPlayerIcon';
import { VoiceMessageIcon } from './VoiceMessageIcon';
import { default as XIcon } from './XIcon/index';

export default {
  AnchorLogoIcon,
  AnchorPayIcon,
  ArrowIcon,
  CheckmarkIcon,
  CircularArrowIcon,
  ClockIcon,
  DollarSignIcon,
  DownloadIcon,
  ExternalLinkIcon,
  EyeDropperIcon,
  GearIcon,
  InfoIcon,
  JustifiedIcon,
  LockIcon,
  MagnifyingGlassIcon,
  MicrophoneIcon,
  OptionDotsIcon,
  PauseIcon,
  PencilIcon,
  PlayIcon,
  PowerIcon,
  QuestionMarkIcon,
  QuoteIcon,
  ReRecordIcon,
  TrashIcon,
  UpsidedownTriangleIcon,
  VideoPlayerIcon,
  VoiceMessageIcon,
  XIcon,
};
